export default __webpack_public_path__ + "static/media/higher_icon_roi.2b8dc663.svg";